{
  "REPORT": {
    "HEADER": "Conversations",
    "LOADING_CHART": "Chargement des données du graphique ...",
    "NO_ENOUGH_DATA": "Nous n'avons pas reçu assez de points de données pour générer un rapport. Veuillez réessayer plus tard.",
    "DOWNLOAD_AGENT_REPORTS": "Télécharger les rapports de l'agent",
    "DATA_FETCHING_FAILED": "Impossible de récupérer les données, veuillez réessayer ultérieurement.",
    "SUMMARY_FETCHING_FAILED": "Impossible de récupérer le résumé, veuillez réessayer plus tard.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversations",
        "DESC": "(Total)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Messages entrants",
        "DESC": "(Total)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Messages sortants",
        "DESC": "(Total)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Délai de première réponse",
        "DESC": "(Moy.)",
        "INFO_TEXT": "Nombre total de conversations utilisées pour le calcul :",
        "TOOLTIP_TEXT": "Le temps de première réponse est {metricValue} (basé sur {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Temps de résolution",
        "DESC": "(Moy.)",
        "INFO_TEXT": "Nombre total de conversations utilisées pour le calcul :",
        "TOOLTIP_TEXT": "Le temps de résolution est {metricValue} (basé sur {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Nombre de résolutions",
        "DESC": "(Total)"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Nombre de résolutions",
        "DESC": "(Total)"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Handoff Count",
        "DESC": "(Total)"
      },
      "REPLY_TIME": {
        "NAME": "Temps d'attente du client",
        "TOOLTIP_TEXT": "Waiting time is {metricValue} (based on {conversationCount} replies)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "TODAY": "Aujourd'hui",
      "YESTERDAY": "Hier",
      "LAST_7_DAYS": "7 derniers jours",
      "LAST_30_DAYS": "30 derniers jours",
      "THIS_MONTH": "Ce mois-ci",
      "LAST_MONTH": "Le mois dernier",
      "LAST_3_MONTHS": "3 derniers mois",
      "LAST_6_MONTHS": "6 derniers mois",
      "LAST_YEAR": "Année dernière",
      "CUSTOM_DATE_RANGE": "Plage de date personnalisée"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Appliquer",
      "PLACEHOLDER": "Sélectionnez la plage de dates"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Par groupe",
    "DURATION_FILTER_LABEL": "Durée",
    "GROUPING_OPTIONS": {
      "DAY": "Jour",
      "WEEK": "Semaine",
      "MONTH": "Mois",
      "YEAR": "Année"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Jour"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Jour"
      },
      {
        "id": 2,
        "groupBy": "Semaine"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Jour"
      },
      {
        "id": 2,
        "groupBy": "Semaine"
      },
      {
        "id": 3,
        "groupBy": "Mois"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Jour"
      },
      {
        "id": 2,
        "groupBy": "Semaine"
      },
      {
        "id": 3,
        "groupBy": "Mois"
      }
    ],
    "BUSINESS_HOURS": "Heures de bureau",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Aucun résultat trouvé"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Conversations : {count}",
      "RESULT_COUNT_MESSAGE": "Messages : {count}",
      "EMPTY": "Aucun enregistrement trouvé pour cette barre.",
      "ERROR": "Impossible de charger les enregistrements. Veuillez réessayer.",
      "LOAD_MORE": "Charger plus",
      "PREVIOUS_BUCKET": "Barre précédente",
      "NEXT_BUCKET": "Barre suivante",
      "UNKNOWN_CONTACT": "Contact inconnu",
      "UNKNOWN_INBOX": "Boîte de réception inconnue",
      "UNASSIGNED_AGENT": "Non assignée",
      "NO_MESSAGE_CONTENT": "Message sans contenu",
      "MESSAGE_CREATED_AT": "Message créé le {time}",
      "EVENT_OCCURRED_AT": "Événement survenu le {time}",
      "INCOMING_MESSAGE": "Message entrant",
      "OUTGOING_MESSAGE": "Message sortant",
      "VIEW_ALL": "Voir dans les conversations",
      "VIEW_ALL_LIMIT": "Seules les barres de {limit} conversations au plus s'ouvrent dans la liste des conversations.",
      "HIDDEN_COUNT": "Non affichés, car vous n'êtes pas membre de leur boîte de réception : {count}"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Présentation des agents",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent’s name to learn more.",
    "LOADING_CHART": "Chargement des données du graphique ...",
    "NO_ENOUGH_DATA": "Nous n'avons pas reçu assez de points de données pour générer un rapport. Veuillez réessayer plus tard.",
    "DOWNLOAD_AGENT_REPORTS": "Télécharger les rapports de l'agent",
    "FILTER_DROPDOWN_LABEL": "Sélectionner un agent",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversations",
        "DESC": "(Total)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Messages entrants",
        "DESC": "(Total)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Messages sortants",
        "DESC": "(Total)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Délai de première réponse",
        "DESC": "(Moy.)",
        "INFO_TEXT": "Nombre total de conversations utilisées pour le calcul :",
        "TOOLTIP_TEXT": "Le temps de première réponse est {metricValue} (basé sur {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Temps de résolution",
        "DESC": "(Moy.)",
        "INFO_TEXT": "Nombre total de conversations utilisées pour le calcul :",
        "TOOLTIP_TEXT": "Le temps de résolution est {metricValue} (basé sur {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Nombre de résolutions",
        "DESC": "(Total)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "7 derniers jours"
      },
      {
        "id": 1,
        "name": "30 derniers jours"
      },
      {
        "id": 2,
        "name": "3 derniers mois"
      },
      {
        "id": 3,
        "name": "6 derniers mois"
      },
      {
        "id": 4,
        "name": "Année dernière"
      },
      {
        "id": 5,
        "name": "Plage de date personnalisée"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Appliquer",
      "PLACEHOLDER": "Sélectionnez la plage de dates"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Présentation des étiquettes",
    "DESCRIPTION": "Suivez les performances des étiquettes grâce à des indicateurs clés : conversations, temps de réponse, temps de résolution et cas résolus.",
    "LOADING_CHART": "Chargement des données du graphique ...",
    "NO_ENOUGH_DATA": "Nous n'avons pas reçu assez de points de données pour générer un rapport. Veuillez réessayer plus tard.",
    "DOWNLOAD_LABEL_REPORTS": "Télécharger les rapports d'étiquettes",
    "FILTER_DROPDOWN_LABEL": "Sélectionnez l'étiquette",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversations",
        "DESC": "(Total)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Messages entrants",
        "DESC": "(Total)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Messages sortants",
        "DESC": "(Total)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Délai de première réponse",
        "DESC": "(Moy.)",
        "INFO_TEXT": "Nombre total de conversations utilisées pour le calcul :",
        "TOOLTIP_TEXT": "Le temps de première réponse est {metricValue} (basé sur {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Temps de résolution",
        "DESC": "(Moy.)",
        "INFO_TEXT": "Nombre total de conversations utilisées pour le calcul :",
        "TOOLTIP_TEXT": "Le temps de résolution est {metricValue} (basé sur {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Nombre de résolutions",
        "DESC": "(Total)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "7 derniers jours"
      },
      {
        "id": 1,
        "name": "30 derniers jours"
      },
      {
        "id": 2,
        "name": "3 derniers mois"
      },
      {
        "id": 3,
        "name": "6 derniers mois"
      },
      {
        "id": 4,
        "name": "Année dernière"
      },
      {
        "id": 5,
        "name": "Plage de date personnalisée"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Appliquer",
      "PLACEHOLDER": "Sélectionnez la plage de dates"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Présentation de la boîte de réception",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "Chargement des données du graphique ...",
    "NO_ENOUGH_DATA": "Nous n'avons pas reçu assez de points de données pour générer un rapport. Veuillez réessayer plus tard.",
    "DOWNLOAD_INBOX_REPORTS": "Télécharger les rapports de la boîte de réception",
    "FILTER_DROPDOWN_LABEL": "Sélectionner la boîte de réception",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversations",
        "DESC": "(Total)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Messages entrants",
        "DESC": "(Total)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Messages sortants",
        "DESC": "(Total)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Délai de première réponse",
        "DESC": "(Moy.)",
        "INFO_TEXT": "Nombre total de conversations utilisées pour le calcul :",
        "TOOLTIP_TEXT": "Le temps de première réponse est {metricValue} (basé sur {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Temps de résolution",
        "DESC": "(Moy.)",
        "INFO_TEXT": "Nombre total de conversations utilisées pour le calcul :",
        "TOOLTIP_TEXT": "Le temps de résolution est {metricValue} (basé sur {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Nombre de résolutions",
        "DESC": "(Total)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "7 derniers jours"
      },
      {
        "id": 1,
        "name": "30 derniers jours"
      },
      {
        "id": 2,
        "name": "3 derniers mois"
      },
      {
        "id": 3,
        "name": "6 derniers mois"
      },
      {
        "id": 4,
        "name": "Année dernière"
      },
      {
        "id": 5,
        "name": "Plage de date personnalisée"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Appliquer",
      "PLACEHOLDER": "Sélectionnez la plage de dates"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Présentation de l'équipe",
    "DESCRIPTION": "Get a snapshot of your team’s performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "Chargement des données du graphique ...",
    "NO_ENOUGH_DATA": "Nous n'avons pas reçu assez de points de données pour générer un rapport. Veuillez réessayer plus tard.",
    "DOWNLOAD_TEAM_REPORTS": "Télécharger les rapports d'équipe",
    "FILTER_DROPDOWN_LABEL": "Choisis une équipe",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversations",
        "DESC": "(Total)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Messages entrants",
        "DESC": "(Total)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Messages sortants",
        "DESC": "(Total)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Délai de première réponse",
        "DESC": "(Moy.)",
        "INFO_TEXT": "Nombre total de conversations utilisées pour le calcul :",
        "TOOLTIP_TEXT": "Le temps de première réponse est {metricValue} (basé sur {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Temps de résolution",
        "DESC": "(Moy.)",
        "INFO_TEXT": "Nombre total de conversations utilisées pour le calcul :",
        "TOOLTIP_TEXT": "Le temps de résolution est {metricValue} (basé sur {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Nombre de résolutions",
        "DESC": "(Total)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "7 derniers jours"
      },
      {
        "id": 1,
        "name": "30 derniers jours"
      },
      {
        "id": 2,
        "name": "3 derniers mois"
      },
      {
        "id": 3,
        "name": "6 derniers mois"
      },
      {
        "id": 4,
        "name": "Année dernière"
      },
      {
        "id": 5,
        "name": "Plage de date personnalisée"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Appliquer",
      "PLACEHOLDER": "Sélectionnez la plage de dates"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "Rapports CSAT",
    "NO_RECORDS": "Il n'y a aucune réponse à l'enquête CSAT disponible.",
    "DOWNLOAD": "Télécharger les rapports CSAT",
    "DOWNLOAD_FAILED": "Le téléchargement des rapports CSAT a échoué",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Choisissez des agents"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Contact",
        "AGENT_NAME": "Agent assigné",
        "RATING": "Note",
        "FEEDBACK_TEXT": "Commentaire sur la rétroaction"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Réponses totales",
        "TOOLTIP": "Nombre total de réponses collectées"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Score de satisfaction",
        "TOOLTIP": "Nombre total de réponses positives / Nombre total de réponses * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Taux de réponse",
        "TOOLTIP": "Nombre total de réponses / Nombre total de messages de l'enquête CSAT envoyés * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot Reports",
    "METRIC": {
      "CONVERSATION_COUNT": {
        "LABEL": "Nombre de conversations",
        "TOOLTIP": "Nombre total de conversations avec des messages de bot"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Nombre de réponses",
        "TOOLTIP": "Nombre total de messages sortants"
      },
      "MESSAGE_COUNT": {
        "LABEL": "Nombre de réponses IA",
        "TOOLTIP": "Nombre total de messages de réponse envoyés par le bot"
      },
      "COPILOT_COUNT": {
        "LABEL": "Nombre de réponses préparées",
        "TOOLTIP": "Nombre total de suggestions copilot préparées par le bot pour les agents"
      },
      "SUCCESS_RATE": {
        "LABEL": "Résolu par IA",
        "TOOLTIP": "Pourcentage de conversations résolues par l'IA sans transfert à un agent"
      },
      "RESOLVE_TIME": {
        "LABEL": "Temps de résolution",
        "TOOLTIP": "Temps médian entre le premier message du client et le dernier message du bot/agent"
      }
    },
    "GROUP_BY": {
      "LABEL": "Regrouper par",
      "NONE": "Ne pas regrouper",
      "INBOXES": "Boîtes de réception",
      "LABELS": "Étiquettes"
    },
    "GROUPED": {
      "CHART_TITLE": "Répartition par groupe",
      "BACK_TO_ALL": "Afficher tout",
      "TABLE": {
        "INBOX": "Boîte de réception",
        "LABEL": "Étiquette",
        "CONVERSATIONS": "Conversations",
        "MESSAGES": "Messages",
        "MESSAGES_TOOLTIP": "Nombre total de messages sortants",
        "AI_MESSAGES": "Réponses IA",
        "AI_MESSAGES_TOOLTIP": "Nombre total de réponses IA, suivi du nombre d'évaluations positives et négatives des utilisateurs finaux",
        "THUMBS_UP_TOOLTIP": "Nombre de réponses IA évaluées positivement (pouce levé) par les utilisateurs finaux",
        "THUMBS_DOWN_TOOLTIP": "Nombre de réponses IA évaluées négativement (pouce baissé) par les utilisateurs finaux",
        "AI_PERCENTAGE": "% IA",
        "AI_PERCENTAGE_TOOLTIP": "Pourcentage de réponses IA par rapport à tous les messages de ce groupe",
        "PREPARED": "Réponses préparées",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "Pourcentage de messages par rapport à tous les messages appartenant à ce groupe",
        "BOT_RESPONSES": "% Réponses IA",
        "SUGGESTION_USED": "Réponses utilisées",
        "SUGGESTION_USED_TOOLTIP": "Pourcentage de réponses préparées dans ce groupe qui ont été utilisées par les agents",
        "SUGGESTION_NOT_USED": "Réponses non utilisées",
        "SUGGESTION_NOT_USED_TOOLTIP": "Pourcentage de messages dans ce groupe qui avaient une réponse préparée mais qui n'a pas été utilisée"
      },
      "NOTES": {
        "TITLE": "Comment les métriques sont calculées",
        "CONVERSATIONS": "Nombre de conversations ayant au moins un message sortant dans la période sélectionnée.",
        "MESSAGES": "Nombre total de messages sortants (non privés) envoyés dans la période sélectionnée. Cela inclut à la fois les messages générés par l'IA et ceux écrits par des humains.",
        "PERCENTAGE": "Part des messages de ce groupe par rapport à tous les messages sortants de tous les groupes.",
        "AI_MESSAGES": "Nombre de messages sortants envoyés automatiquement par le bot IA (sans compter les réponses préparées pour les agents). Les nombres entre parenthèses indiquent combien de ces réponses ont été évaluées positivement (pouce levé) et négativement (pouce baissé) par les utilisateurs finaux.",
        "BOT_RESPONSES_PCT": "Part des réponses IA de ce groupe par rapport à tous les messages sortants de ce groupe.",
        "PREPARED": "Nombre de suggestions copilot (réponses préparées) générées par le bot IA pour les agents dans la période sélectionnée. Ce sont des messages privés visibles uniquement par les agents et ne sont pas comptés comme messages sortants, donc ce nombre peut ne pas correspondre à la colonne Messages.",
        "SUGGESTION_USED": "Pourcentage de réponses préparées dans ce groupe qui ont été utilisées par les agents. Cela peut ne pas correspondre au nombre de réponses préparées car cela peut également inclure des suggestions générées dans des périodes antérieures.",
        "SUGGESTION_NOT_USED": "Pourcentage de messages sortants dans ce groupe où une suggestion copilot était disponible mais où l'agent a répondu sans l'utiliser. Comptabilisé uniquement lorsque l'agent a effectivement envoyé une réponse. Cela peut ne pas correspondre au nombre de réponses préparées car cela peut également inclure des suggestions générées dans des périodes antérieures."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Vue d'ensemble",
    "LIVE": "En direct",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Conversations ouvertes",
      "LOADING_MESSAGE": "Chargement des métriques de la conversation...",
      "OPEN": "Ouvert",
      "UNATTENDED": "Sans surveillance",
      "UNASSIGNED": "Non assigné",
      "PENDING": "En attente"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Trafic des conversations",
      "NO_CONVERSATIONS": "Aucune conversation",
      "CONVERSATION": "Conversation {count}",
      "CONVERSATIONS": "{count} conversations",
      "DOWNLOAD_REPORT": "Download report"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Conversations par des agents",
      "LOADING_MESSAGE": "Chargement des métriques de l'agent...",
      "NO_AGENTS": "Il n'y a aucune conversation par des agents",
      "TABLE_HEADER": {
        "AGENT": "Agent",
        "OPEN": "Ouvert",
        "UNATTENDED": "Sans surveillance",
        "STATUS": "État"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Équipes",
        "OPEN": "Ouvert",
        "UNATTENDED": "Sans surveillance",
        "STATUS": "État"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Statut de l'agent",
      "ONLINE": "En ligne",
      "BUSY": "Occupé(e)",
      "OFFLINE": "Hors-ligne"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Dimanche",
    "MONDAY": "Lundi",
    "TUESDAY": "Mardi",
    "WEDNESDAY": "Mercredi",
    "THURSDAY": "Jeudi",
    "FRIDAY": "Vendredi",
    "SATURDAY": "Samedi"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA Reports",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Loading SLA data...",
    "DOWNLOAD_SLA_REPORTS": "Download SLA reports",
    "DOWNLOAD_FAILED": "Failed to download SLA Reports",
    "DROPDOWN": {
      "ADD_FIlTER": "Ajouter un filtre",
      "CLEAR_ALL": "Clear all",
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Aucun résultat trouvé",
      "NO_FILTER": "No filters available",
      "SEARCH": "Search filter",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA name",
        "AGENTS": "Nom de l'agent",
        "INBOXES": "Nom de la boîte de réception",
        "LABELS": "Nom de l'étiquette",
        "TEAMS": "Nom de l'équipe"
      },
      "SLA": "SLA Policy",
      "INBOXES": "Boîte de réception",
      "AGENTS": "Agent",
      "LABELS": "Étiquettes",
      "TEAMS": "Équipes"
    },
    "WITH": "with",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Hit Rate",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Number of Misses",
        "TOOLTIP": "Total SLA misses in a certain period"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Number of Conversations",
        "TOOLTIP": "Total number of conversations with SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Policy",
        "CONVERSATION": "Conversation",
        "AGENT": "Agent"
      },
      "VIEW_DETAILS": "View Details"
    }
  },
  "SUMMARY_REPORTS": {
    "SUBTOTAL": "Sous-total",
    "NO_TEAM": "Sans équipe",
    "GROUP_BY_TEAMS": "Grouper par équipes",
    "INBOX": "Boîte de réception",
    "AGENT": "Agent",
    "TEAM": "Équipes",
    "LABEL": "Étiquette",
    "TOTAL": "Total",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Nombre de résolutions",
    "CONVERSATIONS": "Nbre de conversations",
    "OUTGOING_CHATS": "Chats sortants",
    "OUTGOING_EMAILS": "E-mails sortants",
    "PHONE_CALLS": "Appels téléphoniques",
    "INBOUND_CALLS": "Appels entrants",
    "OUTBOUND_CALLS": "Appels sortants",
    "TOTAL_ACTIVITIES": "Activités totales",
    "ONLINE_TIME": "Temps en ligne",
    "QUEUE_AVAILABLE_TIME": "Temps disponible en file d'attente",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Nombre de messages sortants envoyés par cet agent",
      "OUTGOING_EMAILS": "Nombre d'e-mails sortants envoyés par cet agent",
      "PHONE_CALLS": "Nombre total d'appels téléphoniques assignés à cet agent (somme des appels entrants et sortants)",
      "TOTAL_ACTIVITIES": "Nombre total d'activités : appels entrants + appels sortants + chats sortants + e-mails sortants",
      "INBOUND_CALLS": "Nombre d'appels téléphoniques entrants assignés à cet agent",
      "OUTBOUND_CALLS": "Nombre d'appels téléphoniques sortants assignés à cet agent",
      "AVG_FIRST_RESPONSE_TIME": "Temps moyen entre la création de la conversation et la première réponse de l'agent dans les conversations assignées à cet agent",
      "AVG_RESOLUTION_TIME": "Temps moyen entre la création de la conversation et sa résolution dans les conversations assignées à cet agent",
      "AVG_REPLY_TIME": "Temps moyen d'attente des clients entre leur message et la réponse de l'agent dans les conversations assignées à cet agent",
      "ONLINE_TIME": "Temps total pendant lequel l'agent était en ligne ou occupé durant la période sélectionnée",
      "QUEUE_AVAILABLE_TIME": "Temps total pendant lequel l'agent était disponible dans les files d'attente téléphoniques durant la période sélectionnée"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Rapports téléphoniques",
    "DESCRIPTION": "Suivez les métriques d'appels téléphoniques avec des informations détaillées sur les appels entrants et sortants, regroupés par agent ou boîte de réception pour une analyse complète.",
    "AGENT_HEADER": "Rapports téléphoniques - Par agent",
    "INBOX_HEADER": "Rapports téléphoniques - Par boîte de réception",
    "DOWNLOAD_BUTTON": "Télécharger les rapports téléphoniques",
    "DOWNLOAD_PHONE_REPORTS": "Télécharger les rapports téléphoniques",
    "GROUP_BY": {
      "LABEL": "Regrouper par",
      "AGENT": "Agent",
      "INBOX": "Boîte de réception"
    },
    "TABLE": {
      "AGENT_NAME": "Nom de l'agent",
      "INBOX_NAME": "Nom de la boîte de réception",
      "TOTAL_CALLS": "Total",
      "INBOUND_CALLS": "Entrants",
      "OUTBOUND_CALLS": "Sortants",
      "FAILED_OUTBOUND_CALLS": "Sortants en échec",
      "AVG_AGENT_HANDLED_DURATION": "Durée moyenne",
      "TOTAL_AGENT_HANDLED_DURATION": "Durée totale",
      "AVG_RINGING_TIME": "Temps de sonnerie moyen",
      "CONNECTED_OUTBOUND_PERCENTAGE": "% Succès",
      "UNIQUE_CALLERS": "Appelants uniques",
      "UNIQUE_CALLED_CONTACTS": "Appelés uniques",
      "UNANSWERED_MISSED_CALLS": "Manqués sans suivi",
      "UNANSWERED_MISSED_PERCENTAGE": "% Manqués sans réponse",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Manqués sans suivi, insuffisamment rappelés",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "% Manqués sans suivi, insuffisamment rappelés"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Nombre total de tous les appels (y compris non connectés)",
      "INBOUND_CALLS": "Nombre d'appels connectés",
      "OUTBOUND_CALLS": "Nombre de tous les appels sortants (y compris non connectés)",
      "FAILED_OUTBOUND_CALLS": "Nombre d'appels sortants qui n'ont pas pu se connecter",
      "AVG_AGENT_HANDLED_DURATION": "Durée moyenne des appels gérés par les agents",
      "TOTAL_AGENT_HANDLED_DURATION": "Durée totale de tous les appels gérés par les agents",
      "AVG_RINGING_TIME": "Temps moyen de sonnerie des appels avant d'être répondus",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Pourcentage d'appels sortants connectés avec succès",
      "UNIQUE_CALLERS": "Nombre de contacts uniques ayant effectué des appels entrants",
      "UNIQUE_CALLED_CONTACTS": "Nombre de contacts uniques appelés via des appels sortants",
      "UNANSWERED_MISSED_CALLS": "Nombre d'appels manqués sans rappel réussi (appel connecté). Peut inclure des appels qui peuvent encore être traités dans la journée de travail",
      "UNANSWERED_MISSED_PERCENTAGE": "Pourcentage d'appelants uniques dont les appels ont été manqués sans suivi (appels manqués sans réponse / appelants uniques)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Nombre d'appels manqués avec moins de 2 tentatives de rappel. Peut inclure des appels qui peuvent encore être traités dans la journée de travail",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Pourcentage d'appelants uniques avec moins de 2 tentatives de rappel ((manqués sans suivi - suffisamment traités) / appelants uniques)"
    },
    "EMPTY_STATE": {
      "TITLE": "Aucune donnée d'appel téléphonique disponible",
      "MESSAGE": "Il n'y a aucun appel téléphonique dans la plage de dates sélectionnée. Essayez d'ajuster vos filtres ou votre plage de dates."
    }
  }
}
